import CustomSearchBar from "components/CustomSearchBar";
import CustomTable from "components/CustomTable";
import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useGetFPOLeadsQuery } from "./FPOApiSlice";
import useDebouncedValue from "hooks/useDebouncedValue";
import { CardHeader } from "reactstrap";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
const FPOLeadsList = () => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };

  const { data: data, isLoading } = useGetFPOLeadsQuery({
    pagination,
    searchKey: debouncedSearch || "",
  });

  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data?.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);

  const columns = [
    { field: "organization_name", headerName: "Organization", width: 200 },

    {
      field: "created_at",
      headerName: "Created At",
      width: 120,
      type: "date",
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY "),
    },
    { field: "phone_number", headerName: "Phone Number", width: 130 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "registration_number", headerName: "COI Number", width: 120 },

    { field: "land_holding", headerName: "Land Holding", width: 130 },
    {
      field: "current_status",
      headerName: "Status",
      width: 210,
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;

        const statusConfig = {
          "LEAD GENERATED": {
            color: "blue",
            icon: <FileTextOutlined />,
          },
          APPROVED: { color: "gold", icon: <CheckCircleOutlined /> },
          REJECTED: { color: "error", icon: <WarningOutlined /> },
          COMPLETED: { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>{status.split("_").join(" ")}</span>
          </Tag>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 80,
      renderCell: (cellvalues) => {
        return (
          <Link to={`/onboarding/leads/FPO/${cellvalues.id}`}>
            {" "}
            <i
              className="p-3 mdi mdi-eye fs-5 text-orange"
              name={"view"}
            />{" "}
          </Link>
        );
      },
    },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
  };

  return (
    <div className="mt-lg-0 mt-md-0 mt-3">
      <CardHeader className="mt-1 ">
        <Row className="">
          <Col md="2">
            <CustomSearchBar sendSearchFunction={handleChangeSearch} />
          </Col>
          <Col lg="2" className="offset-md-8 mt-2">
            Total Leads :{" "}
            <span className="text-success">&nbsp;{data?.data?.total}</span>
          </Col>
        </Row>
      </CardHeader>
      <div className="mt-lg-2 mt-md-3 mt-0">
        <CustomTable
          rows={tableData.rows}
          columns={tableData.columns}
          paginationState={tableData.paginationState}
          loading={tableData.isLoading}
          checkboxShowFalse
        />
      </div>
    </div>
  );
};

export default FPOLeadsList;
